import React, { Component } from 'react';
import { connect } from 'react-redux';
import { translate } from 'react-multi-lang'
import store from '../../store';
import { verifyIdentity, resetForgotPassword, set_OTP, resetUserVerification, validateResetUser } from '../../actions/accountAction';
import Validation from "../hoc/Validation";
import { Link } from 'react-router'
import { sanitizeInput } from '../../helpers';
import { getLocalizedPath } from '../../helpers/languagePath';
import ReactGA from 'react-ga4';

class Resetpassword extends Component {

  constructor(props) {
    super(props);
    this.state = {
      submitStatus: false,
      identitySubmitStatus: false,
      username: '',
      password: '',
      mobile: '',
      pan: '',
      firstname: '',
      lastname: '',
      email: '',
      dob: '',
      formData: {},
      error: '',
      validateError: '',
      identityError: '',
      identityVerified: false,
      identitySuccessMessage: '',
      passwordSubmitStatus: false,
      resetUserType: '',
      resetUserId: '',
      basePath: window.location.protocol + '//' + window.location.host + '/'
    }
    this.handleIdentityVerify = this.handleIdentityVerify.bind(this);
    this.handleUserSentotp = this.handleUserSentotp.bind(this);
    this.handleEmployerIdentityVerify = this.handleEmployerIdentityVerify.bind(this);
  }

  componentDidMount() {
    document.title = this.props.t('login.forgot_pass', { param: 'react' })
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (
      nextProps.JobseekerReducer.msg &&
      window.location.pathname.includes('resetpassword')
    ) {
      const msg = nextProps.JobseekerReducer.msg;
      if (!sessionStorage.getItem('password_reset_success_toast')) {
        sessionStorage.setItem('password_reset_success_toast', msg);
      }
      this.goToSignin();
    }
  }

  componentWillUnmount() {
    if (this._redirecting) {
      return;
    }
    store.dispatch(set_OTP(false))
    store.dispatch(resetUserVerification())
    sessionStorage.removeItem('forgot_password_auth_key')
    sessionStorage.removeItem('forgot_password_mobile')
    sessionStorage.removeItem('forgot_password_email')
    sessionStorage.removeItem('forgot_password_firstname')
    sessionStorage.removeItem('forgot_password_lastname')
    sessionStorage.removeItem('forgot_password_dob')
    sessionStorage.removeItem('forgot_password_pan')
    sessionStorage.removeItem('forgot_password_user_type')
  }

  handleUserInput(e) {
    const name = e.target.name;
    const value = e.target.value;
    this.setState({
      [name]: value,
      submitStatus: false,
      identityError: '',
      validateError: '',
    });
  }

  handleUserSentotp(event) {
    event.preventDefault();

    if (!this.props.validator.fieldValid('mobile')) {
      this.props.validator.showMessageFor('mobile');
      this.forceUpdate();
      return;
    }

    if (this.state.submitStatus) {
      return;
    }

    this.setState({ submitStatus: true, validateError: '', identityError: '' });

    store.dispatch(validateResetUser({ mobile: this.state.mobile }))
      .then((resp) => {
        const data = (resp && resp.data) || {};
        const status = String(data.status || '');
        const userData = data.data || {};
        const userType = String(userData.user_type || '');

        if (status === '404' || data.success === false) {
          this.setState({
            validateError:
              data.message ||
              'No account is registered with this mobile number.',
            submitStatus: false,
          });
          return;
        }

        if (status === '200' || data.success === true) {
          if (userType === '1' || userType === '6') {
            sessionStorage.setItem('forgot_password_mobile', this.state.mobile);
            sessionStorage.setItem('forgot_password_user_type', userType);

            this.setState({
              resetUserType: userType,
              resetUserId: userData.user_id || '',
              mobile: userData.mobile || this.state.mobile,
              submitStatus: false,
              validateError: '',
            });

            store.dispatch(set_OTP(true));
            return;
          }

          const userTypeName = userData.user_type_name
            ? ` (${userData.user_type_name})`
            : '';
          this.setState({
            resetUserType: userType,
            resetUserId: userData.user_id || '',
            submitStatus: false,
            validateError:
              `Password reset is available only for Jobseeker and Employer accounts${userTypeName}. Please contact support for assistance.`,
          });
          return;
        }

        this.setState({
          validateError:
            data.message ||
            'Unable to validate mobile number. Please try again.',
          submitStatus: false,
        });
      })
      .catch(() => {
        this.setState({
          validateError: 'Unable to validate mobile number. Please try again.',
          submitStatus: false,
        });
      });
  }

  isIdentityVerified = (resp) => {
    if (!resp || !resp.data) {
      return false;
    }

    const isSuccessStatus =
      resp.data.status === "200" || resp.data.status === 200;

    const isVerified =
      resp.data.verified === true ||
      resp.data.verified === "true" ||
      (resp.data.data && resp.data.data.identity_verified === true);

    return isSuccessStatus && isVerified;
  }

  handleIdentityVerify(event) {
    event.preventDefault();
    const {
      mobile,
      firstname,
      lastname,
      email,
      dob,
      identitySubmitStatus,
    } = this.state;

    if (identitySubmitStatus) {
      return;
    }

    // Jobseeker verify form currently shows: mobile, firstname, dob
    const isValid =
      this.props.validator.fieldValid('mobile') &&
      this.props.validator.fieldValid('firstname') &&
      this.props.validator.fieldValid('dob');

    if (!isValid) {
      this.props.validator.showMessages();
      this.forceUpdate();
      return;
    }

    this.setState({ identitySubmitStatus: true, identityError: '' });

    store.dispatch(verifyIdentity({
      user_type: '1',
      firstname: (firstname || '').trim(),
      lastname: (lastname || '').trim(),
      email: (email || '').trim(),
      dob,
      mobile,
    }))
      .then((resp) => {
        if (this.isIdentityVerified(resp)) {
          sessionStorage.setItem('forgot_password_mobile', mobile);
          sessionStorage.setItem('forgot_password_email', email || '');
          sessionStorage.setItem('forgot_password_firstname', firstname);
          sessionStorage.setItem('forgot_password_lastname', lastname || '');
          sessionStorage.setItem('forgot_password_dob', dob);
          sessionStorage.setItem('forgot_password_user_type', '1');
          this.setState({
            mobile,
            firstname,
            lastname: lastname || '',
            email: email || '',
            dob,
            resetUserType: '1',
            identityVerified: true,
            identitySuccessMessage:
              (resp && resp.data && resp.data.message) ||
              'Identity verified successfully.',
          });
          document.body.scrollTop = 0;
          document.documentElement.scrollTop = 0;
          return;
        }

        this.setState({
          identityError: (resp && resp.data && resp.data.message) || 'Identity verification failed',
        });
      })
      .catch((error) => {
        const errData = error && error.response && error.response.data;
        this.setState({
          identityError:
            (errData && errData.message) ||
            'Identity verification failed. Please try again.',
        });
      })
      .finally(() => {
        this.setState({ identitySubmitStatus: false });
      });
  }

  handleEmployerIdentityVerify(event) {
    event.preventDefault();
    const { mobile, pan, identitySubmitStatus } = this.state;

    if (identitySubmitStatus) {
      return;
    }

    const isValid =
      this.props.validator.fieldValid('mobile') &&
      this.props.validator.fieldValid('pan');

    if (!isValid) {
      this.props.validator.showMessages();
      this.forceUpdate();
      return;
    }

    this.setState({ identitySubmitStatus: true, identityError: '' });

    const panValue = String(pan || '').trim().toUpperCase();

    store.dispatch(verifyIdentity({
      user_type: '6',
      mobile,
      org_pan: panValue,
    }))
      .then((resp) => {
        if (this.isIdentityVerified(resp)) {
          sessionStorage.setItem('forgot_password_mobile', mobile);
          sessionStorage.setItem('forgot_password_pan', panValue);
          sessionStorage.setItem('forgot_password_user_type', '6');
          this.setState({
            mobile,
            pan: panValue,
            resetUserType: '6',
            identityVerified: true,
            identitySuccessMessage:
              (resp && resp.data && resp.data.message) ||
              'Identity verified successfully.',
          });
          document.body.scrollTop = 0;
          document.documentElement.scrollTop = 0;
          return;
        }

        this.setState({
          identityError:
            (resp && resp.data && resp.data.message) ||
            'Identity verification failed',
        });
      })
      .catch(() => {})
      .finally(() => {
        this.setState({ identitySubmitStatus: false });
      });
  }

  handleInputs = (e) => {
    const { name, value } = e.target;
    this.setState({
      formData: {
        ...this.state.formData,
        [name]: value,
      },
      error: '',
    });
  }

  goToSignin = (message) => {
    this._redirecting = true;
    store.dispatch(resetUserVerification());
    store.dispatch(set_OTP(false));

    if (message && !sessionStorage.getItem('password_reset_success_toast')) {
      sessionStorage.setItem('password_reset_success_toast', message);
    }

    window.location.href = window.location.origin + getLocalizedPath('signin');
  }

  redirectToSignin = (message) => {
    this.goToSignin(message);
  }

  // OTP disabled — resend not used
  // resendOtp = () => {
  //   if (this.state.mobile) {
  //     store.dispatch(Resendotp({ mobile: this.state.mobile }));
  //   }
  // }

  // OTP disabled — auth key validation not used without OTP flow
  // isValidAuthKey = (authKey, mobile, email) => {
  //   const normalizedKey = String(authKey || '').trim();
  //   return Boolean(
  //     normalizedKey &&
  //     normalizedKey !== String(mobile || '').trim() &&
  //     normalizedKey !== String(email || '').trim()
  //   );
  // }

  submit = async (e) => {
    e.preventDefault();

    if (this.state.passwordSubmitStatus) {
      return;
    }

    const verifiedObject = this.props.notificationReducer.verfiedObject || {};
    const mobile =
      verifiedObject.mobile ||
      sessionStorage.getItem('forgot_password_mobile') ||
      this.state.mobile ||
      '';
    const email =
      verifiedObject.email ||
      sessionStorage.getItem('forgot_password_email') ||
      this.state.email ||
      '';
    const firstname =
      verifiedObject.firstname ||
      sessionStorage.getItem('forgot_password_firstname') ||
      this.state.firstname ||
      '';
    const lastname =
      verifiedObject.lastname ||
      sessionStorage.getItem('forgot_password_lastname') ||
      this.state.lastname ||
      '';
    const dob =
      verifiedObject.dob ||
      sessionStorage.getItem('forgot_password_dob') ||
      this.state.dob ||
      '';
    const pan =
      verifiedObject.org_pan ||
      verifiedObject.pan ||
      sessionStorage.getItem('forgot_password_pan') ||
      this.state.pan ||
      '';
    const userType =
      verifiedObject.user_type ||
      this.state.resetUserType ||
      sessionStorage.getItem('forgot_password_user_type') ||
      '';
    const authKey =
      verifiedObject.auth_key ||
      (verifiedObject.data && verifiedObject.data.auth_key) ||
      sessionStorage.getItem('forgot_password_auth_key') ||
      '';

    const passwordInput = document.getElementById('password_new');
    const confirmInput = document.getElementById('confirm_password');
    const newPassword = sanitizeInput(
      (passwordInput && passwordInput.value) ||
      (this.state.formData && this.state.formData.password) ||
      ''
    );
    const confirmPassword = sanitizeInput(
      (confirmInput && confirmInput.value) ||
      (this.state.formData && this.state.formData.confirm_password) ||
      ''
    );

    if (!this.state.identityVerified) {
      return;
    }

    if (!mobile) {
      this.setState({
        error: 'Verification session expired. Please verify your account again.',
      });
      setTimeout(() => this.setState({ error: '' }), 3000);
      return;
    }

    // OTP verification disabled
    // if (!otp || otp.length < 4) {
    //   this.setState({ error: 'Please enter the OTP sent to your mobile.' });
    //   return;
    // }

    if (!newPassword || !confirmPassword) {
      this.setState({ error: 'Please enter password and confirm password.' });
      return;
    }

    if (newPassword.length < 6 || confirmPassword.length < 6) {
      this.setState({ error: 'Password must be at least 6 characters.' });
      return;
    }

    if (newPassword !== confirmPassword) {
      this.setState({ error: 'Password does not match' });
      setTimeout(() => this.setState({ error: '' }), 2000);
      return;
    }

    this.setState({ passwordSubmitStatus: true, error: '' });

    try {
      const result = await store.dispatch(resetForgotPassword({
        user_type: String(userType) === '6' ? '6' : '1',
        mobile,
        email,
        firstname,
        lastname,
        dob,
        org_pan: pan,
        password: newPassword,
        auth_key: authKey,
      }));

      const respData = (result && result.resp && result.resp.data) || {};
      const status = respData.status;
      const message = respData.message || '';
      const isSuccess =
        (result && result.success) ||
        status === '200' ||
        status === 200;
      const isFailure =
        status === '401' ||
        status === 401 ||
        respData.verified === false ||
        respData.verified === 'false' ||
        /auth key and new password are required|invalid|mismatch|does not match|unable|could not|failed/i.test(
          message
        );

      if (isSuccess && !isFailure) {
        this.goToSignin(message || 'Password updated successfully.');
        return;
      }

      this.setState({
        error: message || (result && result.message) || 'Unable to reset password. Please try again.',
      });
    } catch (error) {
      const errData = error && error.response && error.response.data;
      this.setState({
        error:
          (errData && errData.message) ||
          (typeof errData === 'string' ? errData : '') ||
          'Unable to reset password. Please try again.',
      });
    } finally {
      if (!this._redirecting) {
        this.setState({ passwordSubmitStatus: false });
      }
    }
  };

  change = (id, e) => {
    let inputType = document.getElementById(id).type
    if (inputType === 'password') {
      document.getElementById(id).type = 'text'
      e.target.className = e.target.className.substring(0, e.target.className.lastIndexOf("-"));
    } else {
      document.getElementById(id).type = 'password'
      e.target.className += '-slash'
    }
  }

  render() {
    if (localStorage.getItem('Islogin') && localStorage.getItem('Islogin') !== 'false') {
      window.location.href = this.state.basePath + 'myaccount'
    }

    const { validator } = this.props
    const { password, confirm_password } = this.state.formData
    const {
      mobile,
      pan,
      firstname,
      lastname,
      email,
      dob,
      identityError,
      validateError,
      identitySubmitStatus,
      identityVerified,
      identitySuccessMessage,
      resetUserType,
      submitStatus,
    } = this.state

    let Mainprops = this.props;
    const userType =
      resetUserType ||
      sessionStorage.getItem('forgot_password_user_type') ||
      '';
    const isJobseekerReset = String(userType) === '1';
    const isEmployerReset = String(userType) === '6';
    const showIdentityForm =
      Mainprops.notificationReducer.openotp && !identityVerified && isJobseekerReset;
    const showEmployerIdentityForm =
      Mainprops.notificationReducer.openotp && !identityVerified && isEmployerReset;
    const showChangePassword = identityVerified;

    return (
      <section className="login-form main-content-height item-center">
        <div className="container">
          <div className="row mt-5">
            <div className="col-md-12 cover-shadow justify-content-center align-self-center   border-0">
              <div className=" row ">
                <div className="col-sm-6 first-click-inst text-left">
                  <h1 className='fs20px'>{this.props.t('login.forgotpass_head', { param: 'react' })}</h1>
                  <ul className="jobseeker-benefits">
                    <li>{this.props.t('login.forgotpass_inst1', { param: 'react' })}</li>
                    <li>{this.props.t('login.forgotpass_inst2', { param: 'react' })}</li>
                    <li>{this.props.t('login.forgotpass_inst3', { param: 'react' })}</li>
                  </ul>
                </div>
                {!Mainprops.notificationReducer.openotp &&
                  <form
                    className="col-md-6 col-md-6 pt-5 pl-4 pr-4"
                    onSubmit={this.handleUserSentotp}
                    aria-label="Forgot Password Form"
                  >
                    <div className="form-group">
                      <div className="col-sm-12 p-0 text-left">
                        <p htmlFor="mobile" className='mb-2'>
                          {this.props.t("login.forgotpass_inst1", { param: "react" })}
                        </p>
                        <input
                          onChange={(event) => this.handleUserInput(event)}
                          onBlur={() => this.props.validator.showMessageFor("mobile")}
                          className="form-control"
                          placeholder={this.props.t("forms.enterMobile", { param: "react" })}
                          name="mobile"
                          type="number"
                          inputMode="numeric"
                          maxLength="10"
                          id="mobile"
                          value={this.state.mobile || ''}
                          title="Enter your 10-digit mobile number"
                          aria-required="true"
                          autoComplete="tel"
                        />
                        {validator.message("mobile", this.state.mobile, "required|phone|numeric|max:10")}
                      </div>

                      {validateError &&
                        <div className="form-group mt-2" style={{ textAlign: 'center' }}>
                          <span style={{ color: 'red' }}>{validateError}</span>
                        </div>}

                      <button
                        type="submit"
                        className="btn btn-primary btn-primary2 mt-3"
                        title="Submit your mobile number"
                        aria-label="Submit"
                        disabled={submitStatus}
                        onClick={() => {
                          ReactGA.event({
                            category: 'Auth',
                            action: 'Reset Button Submit',
                            label: 'Reset Button'
                          });
                        }}
                      >
                        {submitStatus
                          ? this.props.t("profileDetails.submit", { param: "react" }) + '...'
                          : this.props.t("profileDetails.submit", { param: "react" })}
                      </button>

                      <div>
                        <Link
                          to="/"
                          className="btn btn-light mt-3 border"
                          title="Go back to home page"
                          aria-label="Back"
                        >
                          Back
                        </Link>
                      </div>
                    </div>
                  </form>
                }
                {showChangePassword &&
                  <form className="col-md-6 col-md-6 pt-5 pl-4 pr-4 pb-2" onSubmit={this.submit}>
                    <h4>{this.props.t('changePassword.title', { param: 'react' })}</h4>
                    <hr />

                    {identitySuccessMessage &&
                      <div className="alert alert-success" role="alert">
                        {identitySuccessMessage}
                      </div>
                    }

                    {/* OTP verification disabled — password reset without OTP */}
                    {/* <div className="form-group">
                      <label>OTP</label>
                      <p className="mb-2" style={{ fontSize: '12px' }}>
                        {this.props.t('login.code', { param: 'react' })}
                        {this.props.t('login.substring', { param: 'react' })}
                        {(mobile || '').substring(6)}
                      </p>
                      <input
                        type="number"
                        onChange={(event) => this.handleUserInput(event)}
                        className="form-control"
                        id="reset-otp"
                        name="opt"
                        aria-label="Enter OTP"
                        aria-required="true"
                        autoComplete="one-time-code"
                        value={this.state.opt || ''}
                      />
                      <span
                        role="button"
                        tabIndex="0"
                        onClick={this.resendOtp}
                        className="mt-2 d-inline-block date-clr"
                        style={{ cursor: 'pointer', fontSize: '12px' }}
                      >
                        {this.props.t('login.resend_otp', { param: 'react' })}
                      </span>
                    </div> */}

                    <div className="form-group">
                      <div className="row">
                        <div className="col-sm-12 position-relative">
                          <label>{this.props.t('changePassword.new', { param: 'react' })}</label>
                          <input type="password" className="form-control form-eye" aria-label='Enter password'
                            value={password ? password : ''}
                            onChange={this.handleInputs}
                            aria-required="true"
                            autoComplete="new-password"
                            id="password_new" name="password" maxLength="15" minLength="6"
                            placeholder={this.props.t('placeholder.enter', { param: 'react' }) + ' ' + this.props.t('changePassword.new', { param: 'react' })} />
                          <span role="button" tabIndex="0"
                            onClick={(e) => this.change('password_new', e)}
                            className="input fa fa-fw field-icon toggle-password fa-eye-slash"
                          ></span>
                          {validator.message('password', password, 'required')}
                        </div>
                      </div>
                    </div>
                    <div className="form-group">
                      <div className="row">
                        <div className="col-sm-12 position-relative">
                          <label>{this.props.t('changePassword.confirm', { param: 'react' })}</label>
                          <input type="password"
                            onChange={this.handleInputs}
                            aria-required="true"
                            autoComplete="new-password"
                            value={confirm_password ? confirm_password : ''}
                            className="form-control form-eye"
                            maxLength="15" minLength="6"
                            id="confirm_password"
                            name="confirm_password"
                            aria-label='Enter confirm password'
                            placeholder={this.props.t('changePassword.confirm', { param: 'react' })} />
                          <span
                            onClick={(e) =>
                              this.change('confirm_password', e)}
                            toggle="#confirm_password"
                            className="input fa fa-fw field-icon toggle-password fa-eye-slash"
                          ></span>
                          {validator.message('confirm password', confirm_password, 'required')}
                        </div>
                      </div>
                    </div>

                    {this.state.error &&
                      <div className="form-group" style={{ 'textAlign': 'center' }}>
                        <span style={{ 'color': 'red' }}>{this.state.error}</span>
                      </div>}
                    <button
                      aria-label='Submit new password'
                      type="submit"
                      className="btn btn-primary btn-primary2 mt-3"
                      disabled={this.state.passwordSubmitStatus}
                    >
                      {this.state.passwordSubmitStatus
                        ? this.props.t('profileDetails.submit', { param: 'react' }) + '...'
                        : this.props.t('profileDetails.submit', { param: 'react' })}
                    </button>
                  </form>
                }
                {showIdentityForm &&
                  <form
                    className="col-md-6 col-md-6 pt-5 pl-4 pr-4 pb-2"
                    onSubmit={this.handleIdentityVerify}
                    aria-label="Verify your account form"
                  >
                    <h4>{this.props.t('login.verify_no', { param: 'react' })}</h4>
                    <hr />

                    <div className="form-group">
                      <label>{this.props.t('profileDetails.mobile', { param: 'react' })}</label>
                      <input
                        onChange={(event) => this.handleUserInput(event)}
                        onBlur={() => this.props.validator.showMessageFor('mobile')}
                        className="form-control"
                        placeholder={this.props.t('forms.enterMobile', { param: 'react' })}
                        name="mobile"
                        type="number"
                        inputMode="numeric"
                        maxLength="10"
                        id="verify-mobile"
                        value={mobile || ''}
                        disabled={Boolean(mobile)}
                        readOnly={Boolean(mobile)}
                        aria-required="true"
                        autoComplete="tel"
                      />
                      {validator.message('mobile', mobile, 'required|phone|numeric|max:10')}
                    </div>

                    <div className="form-group">
                      <label>{this.props.t('profileDetails.fname', { param: 'react' })}</label>
                      <input
                        onChange={(event) => this.handleUserInput(event)}
                        onBlur={() => this.props.validator.showMessageFor('firstname')}
                        className="form-control"
                        placeholder={this.props.t('profileDetails.fnameDesc', { param: 'react' })}
                        name="firstname"
                        type="text"
                        id="verify-firstname"
                        value={firstname || ''}
                        aria-required="true"
                        autoComplete="given-name"
                      />
                      {validator.message('firstname', firstname, 'required')}
                    </div>

                    {/* <div className="form-group">
                      <label>{this.props.t('profileDetails.lname', { param: 'react' })}</label>
                      <input
                        onChange={(event) => this.handleUserInput(event)}
                        onBlur={() => this.props.validator.showMessageFor('lastname')}
                        className="form-control"
                        placeholder={this.props.t('profileDetails.lnameDesc', { param: 'react' })}
                        name="lastname"
                        type="text"
                        id="verify-lastname"
                        value={lastname || ''}
                        aria-required="true"
                        autoComplete="family-name"
                      />
                      {validator.message('lastname', lastname, 'required')}
                    </div>

                    <div className="form-group">
                      <label>{this.props.t('profileDetails.email', { param: 'react' })}</label>
                      <input
                        onChange={(event) => this.handleUserInput(event)}
                        onBlur={() => this.props.validator.showMessageFor('email')}
                        className="form-control"
                        placeholder={this.props.t('profileDetails.emailDesc', { param: 'react' })}
                        name="email"
                        type="email"
                        id="verify-email"
                        value={email || ''}
                        aria-required="true"
                        autoComplete="email"
                      />
                      {validator.message('email', email, 'required|email')}
                    </div> */}

                    <div className="form-group">
                      <label>{this.props.t('profileDetails.dob', { param: 'react' })}</label>
                      <input
                        onChange={(event) => this.handleUserInput(event)}
                        onBlur={() => this.props.validator.showMessageFor('dob')}
                        className="form-control"
                        name="dob"
                        type="date"
                        id="verify-dob"
                        value={dob || ''}
                        max={new Date().toISOString().split('T')[0]}
                        aria-required="true"
                      />
                      {validator.message('dob', dob, 'required')}
                    </div>

                    {identityError &&
                      <div className="form-group" style={{ textAlign: 'center' }}>
                        <span style={{ color: 'red' }}>{identityError}</span>
                      </div>}

                    <button
                      type="submit"
                      className="btn btn-primary btn-primary2 mt-3"
                      disabled={identitySubmitStatus}
                      aria-label="Verify identity"
                    >
                      {identitySubmitStatus
                        ? this.props.t('profileDetails.submit', { param: 'react' }) + '...'
                        : this.props.t('profileDetails.submit', { param: 'react' })}
                    </button>
                  </form>
                }
                {showEmployerIdentityForm &&
                  <form
                    className="col-md-6 col-md-6 pt-5 pl-4 pr-4 pb-2"
                    onSubmit={this.handleEmployerIdentityVerify}
                    aria-label="Verify employer account form"
                  >
                    <h4>{this.props.t('login.verify_no', { param: 'react' })}</h4>
                    <hr />

                    <div className="form-group">
                      <label>Registered Mobile No</label>
                      <input
                        onChange={(event) => this.handleUserInput(event)}
                        onBlur={() => this.props.validator.showMessageFor('mobile')}
                        className="form-control"
                        placeholder={this.props.t('forms.enterMobile', { param: 'react' })}
                        name="mobile"
                        type="number"
                        inputMode="numeric"
                        maxLength="10"
                        id="employer-verify-mobile"
                        value={mobile || ''}
                        disabled={Boolean(mobile)}
                        readOnly={Boolean(mobile)}
                        aria-required="true"
                        autoComplete="tel"
                      />
                      {validator.message('mobile', mobile, 'required|phone|numeric|max:10')}
                    </div>

                    <div className="form-group">
                      <label>Registered PAN No</label>
                      <input
                        onChange={(event) => this.handleUserInput(event)}
                        onBlur={() => this.props.validator.showMessageFor('pan')}
                        className="form-control"
                        placeholder="Enter Organization PAN"
                        name="pan"
                        type="text"
                        id="employer-verify-pan"
                        value={pan || ''}
                        maxLength="10"
                        aria-required="true"
                        autoComplete="off"
                        style={{ textTransform: 'uppercase' }}
                      />
                      {validator.message(
                        'pan',
                        pan,
                        'required|regex:^([a-zA-Z]){5}([0-9]){4}([a-zA-Z]){1}?$'
                      )}
                    </div>

                    {identityError &&
                      <div className="form-group" style={{ textAlign: 'center' }}>
                        <span style={{ color: 'red' }}>{identityError}</span>
                      </div>}

                    <button
                      type="submit"
                      className="btn btn-primary btn-primary2 mt-3"
                      disabled={identitySubmitStatus}
                      aria-label="Verify employer identity"
                    >
                      {identitySubmitStatus
                        ? this.props.t('profileDetails.submit', { param: 'react' }) + '...'
                        : this.props.t('profileDetails.submit', { param: 'react' })}
                    </button>
                  </form>
                }
              </div>
            </div>
          </div>
        </div>
      </section>
    );
  }
}

const mapStateToProps = store => {
  return store;
};

export default connect(mapStateToProps)(translate(Validation(Resetpassword)));